import { render, staticRenderFns } from "./SpindleSpeedPanel.vue?vue&type=template&id=02513748&scoped=true"
import script from "./SpindleSpeedPanel.vue?vue&type=script&lang=ts"
export * from "./SpindleSpeedPanel.vue?vue&type=script&lang=ts"
import style0 from "./SpindleSpeedPanel.vue?vue&type=style&index=0&id=02513748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02513748",
  null
  
)

export default component.exports